import React, { FunctionComponent } from 'react';
import { Totaliser } from '@justgiving/totaliser';
import { Trans, useTranslation } from 'react-i18next';
import parseCurrency from '../../utils/parseCurrency';
import raisedPercentage from '../../utils/raisedPercentage';
import classNames from 'classnames';
import styles from './MemberTotals.scss';
import { PageStatus } from '../../../types/__generated__';

export type MemberTotalsProps = {
  targetAmount: number;
  raisedAmount: number;
  currencyCode: string;
  pageStatus: PageStatus | string;
};

const MemberTotals: FunctionComponent<MemberTotalsProps> = ({
  targetAmount,
  raisedAmount,
  currencyCode,
  pageStatus,
}) => {
  const { t } = useTranslation('common', { useSuspense: false });
  const percentage = raisedPercentage(targetAmount, raisedAmount);
  const isPageCancelled = pageStatus === PageStatus.Cancelled;

  return (
    <>
      {targetAmount > 0 && !isPageCancelled && (
        <div className={styles.totaliser} data-qa="member-totaliser">
          <Totaliser size="small" percent={percentage} />
        </div>
      )}

      <div
        className={classNames(styles.totals, 'jg-space-mbsm jg-space-mbn@xl')}
        data-qa="member-total"
      >
        <div
          className={classNames('jg-text--brand', 'jg-text-color-branded', {
            [styles.cancelled]: isPageCancelled,
          })}
        >
          {parseCurrency(currencyCode, raisedAmount / 100)}
        </div>

        {targetAmount > 0 && !isPageCancelled ? (
          <Trans i18nKey="members.raisedOfTarget">
            raised of{' '}
            <strong>
              {{
                targetAmount: parseCurrency(currencyCode, targetAmount / 100),
              }}{' '}
              target
            </strong>
          </Trans>
        ) : (
          t('members.raisedNoTarget')
        )}
      </div>
    </>
  );
};

export default MemberTotals;
